// @flow
import type {Element} from 'react'
import React, {Component} from 'react'
import Close from 'components/ui/icons/md/Close'

import IconButton from 'components/ui/Inputs/IconButton'
import type {Path} from 'components/proposals/types'

type Props = {
  onClick: (path: Path) => void,
  path: Path,
}

class DeleteButton extends Component<Props> {
  constructor(props: Props) {
    super(props)
    this.onClick = () => props.onClick(props.path)
  }

  onClick: Function

  render(): Element<"div"> {
    return (
      <div className="refinery-accordian-delete-button">
        <IconButton onClick={this.onClick} title={I18n.t('buttons.close')}>
          <Close />
        </IconButton>
      </div>
    )
  }
}

export default DeleteButton
